/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dataset: NonNullable<unknown>, event: NonNullable<unknown> }} Agent_Event_Trigger_Dataset_Rows_SummaryInputs */



/**
* | output |
* | --- |
* | "When {dataset} reports {event}" |
*
* @param {Agent_Event_Trigger_Dataset_Rows_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_dataset_rows_summary = /** @type {((inputs: Agent_Event_Trigger_Dataset_Rows_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Dataset_Rows_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wenn ${i?.dataset} ${i?.event} meldet`)
	return /** @type {LocalizedString} */ (`When ${i?.dataset} reports ${i?.event}`)
});